import type { AttributesType, EditorExecCommandEvent } from './RichTextEditor.types';

const COLORS_MAP = [
  '000000',
  'Black',
  '444444',
  'Charcoal',
  '666666',
  'Dim Grey',
  '999999',
  'Grey',
  'cccccc',
  'Very Light Grey',
  'eeeeee',
  'White Smoke',
  'f3f3f3',
  'White Smoke Light',
  'ffffff',
  'White',

  'f4cccc',
  'Coral Candy',
  'fce5cd',
  'Serenade',
  'fff2cc',
  'Blanced Almond',
  'd9ead3',
  'Peppermind',
  'd0e0e3',
  'Iceberg',
  'cfe2f3',
  'Anahau',
  'd9d2e9',
  'Blue Chalk',
  'ead1dc',
  'Vanilla Ice',

  'ea9999',
  'Tonys Pink',
  'f9cb9c',
  'Apricot',
  'ffe599',
  'Cream Brule',
  'b6d7a8',
  'Moss Green',
  'a2c4c9',
  'Shadow Green',
  '9fc5e8',
  'Sail',
  'b4a7d6',
  'Biloba Flower',
  'd5a6bd',
  'Melanie',

  'e06666',
  'Froly',
  'f6b26b',
  'Tacao',
  'ffd966',
  'Dandelion',
  '93c47d',
  'Olivine',
  '76a5af',
  'Neptune',
  '6fa8dc',
  'Jordy Blue',
  '8e7cc3',
  'Moody Blue',
  'c27ba0',
  'Puce',

  'cc0000',
  'Speech Red',
  'e69138',
  'California',
  'f1c232',
  'Saffron',
  '6aa84f',
  'Apple',
  '45818e',
  'Jelly bean',
  '3d85c6',
  'Curious Blue',
  '674ea7',
  'Studio',
  'a64d79',
  'Royal Heath',

  '990000',
  'Sangria',
  'b45f06',
  'Tawny',
  'bf9000',
  'Dark Goldenrod',
  '38761d',
  'Bilbao',
  '134f5c',
  'Blue Stone',
  '0b5394',
  'Dark Cerulean',
  '351c75',
  'Midnight Blue',
  '741b47',
  'Pompadour',

  '660000',
  'Maroon',
  '783f04',
  'Saddle Brown',
  '7f6000',
  'Olive',
  '274e13',
  'Verdun Green',
  '0c343d',
  'Cyprus',
  '073763',
  'Sapphire',
  '20124d',
  'Midnight Blue',
  '4c1130',
  'Pohutukawa',
];

const DEFAULT_CONFIG = {
  branding: false,
  cache_suffix: '?v=4.5.7',
  browser_spellcheck: true,
  valid_elements: '#*[*]',
  textcolor_rows: '7',
  textcolor_map: COLORS_MAP,
  paste_as_text: false,
  menubar: false,
  convert_urls: false,
  custom_undo_redo_levels: 1,
  entity_encoding: 'raw',
};

const FONT_SIZES =
  '8px 10px 12px 14px 16px 18px 21px 24px 28px 32px 36px 42px 48px 56px 64px 72px 80px 88px 96px 104px 120px 144px';

const EMAIL_EDITOR = 'email';
const ENCORE_EDITOR = 'encore';
const SIMPLE_EDITOR = 'simple';

const elementSpecificConfig = (style: string) => {
  switch (style) {
    case SIMPLE_EDITOR:
      return {
        toolbar: 'bold italic underline link | removeformat',
        plugins: 'link paste',
      };
    case EMAIL_EDITOR:
      return {
        toolbar:
          'builder_formatselect builder_fontsizeselect | bold italic underline strikethrough forecolor backcolor link | alignmentsplit bullist numlist customFieldsCombo | removeformat',
        plugins:
          'lists textcolor colorpicker link autolink paste customFieldsPlugin alignmentsplit builder_formatselect builder_fontsizeselect characterStyleSplit',
      };
    case ENCORE_EDITOR:
      return {
        toolbar:
          'builder_formatselect builder_fontsizeselect | bold italic underline strikethrough forecolor backcolor link | alignmentsplit bullist numlist | removeformat',
        plugins:
          'lists textcolor colorpicker link autolink paste alignmentsplit builder_formatselect builder_fontsizeselect characterStyleSplit',
      };
    default:
      return {
        toolbar:
          'builder_formatselect | bold italic underline strikethrough forecolor backcolor link hr | alignmentsplit outdent indent bullist numlist | removeformat',
        plugins:
          'lists textcolor colorpicker link autolink paste hr alignmentsplit builder_formatselect characterStyleSplit',
      };
  }
};

export const mobileToolbar = (style: string) => {
  const config = elementSpecificConfig(style);
  const characterStyleButtons = 'bold italic underline strikethrough';
  return config.toolbar.replace(characterStyleButtons, 'characterStyleSplit');
};

export const editorConfig = (attributes: AttributesType) => ({
  ...DEFAULT_CONFIG,
  ...elementSpecificConfig(attributes.style),
  ...(window.Kajabi?.themeBuilder?.colorOptions || {}),
});

// eslint-disable-next-line consistent-return
export const beforeExecCommand = (e: EditorExecCommandEvent) => {
  const { command } = e;
  // Prevent TinyMCE native undo/redo in favor of theme builder undo/redo
  if (command === 'Undo' || command === 'Redo') {
    e.preventDefault();
    return false;
  }
};
